import classNames from 'classnames';
import flatten from 'lodash/flatten';
import React, { useMemo } from 'react';

import { Dialog, Space, Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { GROUP_NAME_BY_TYPE } from '../../constants/organizations';
import { IPartnersInfoResult } from '../../interfaces/news';

import { OrgTeg } from './components/OrgTeg/OrgTeg';
import styles from './styles.module.scss';

interface IProps {
  partners: IPartnersInfoResult;

  className?: string;
}

export const OrgDialogSelector: React.FC<IProps> = ({ partners, className }) => {
  const [isOpened, setIsOpened] = useBoolean();
  const orgs = flatten(Object.values(partners));

  const letters = useMemo(
    () =>
      Object.entries(partners).map(([type, optionsGroup]) => (
        <Space key={type} className={styles['orgs-block']} direction="vertical">
          <Typography.Text size={16} className={styles.subtitle}>
            {GROUP_NAME_BY_TYPE[type]}
          </Typography.Text>
          {optionsGroup?.map(OrgTeg)}
        </Space>
      )),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [partners],
  );

  return (
    <>
      <Space size={0} className={classNames(styles.wrapper, className)}>
        {orgs.map(OrgTeg)}
        <Typography.Link onClick={setIsOpened.on} className={styles.button}>
          Ещё
        </Typography.Link>
      </Space>
      <Dialog className={styles.dialog} visible={isOpened} onClose={setIsOpened.off}>
        <Typography.Heading className={styles.header} level={3}>
          Все компании
        </Typography.Heading>
        <div className={styles['orgs-wrapper']}>
          <div className={styles['orgs-content']}>{letters}</div>
        </div>
      </Dialog>
    </>
  );
};
